import { await1kke5zj2piplv as await_0 } from '../context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ReactiveStatel8ixobo86msn as ReactiveState,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
} from '../core/ReactiveState.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Reactive1jy75v4li6ldv as Reactive,
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
} from '../core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_waitForNotNull(_this__u8e3s4) {
  return new (waitForNotNull$1())(_this__u8e3s4);
}
function *_generator_awaitNotNull__3s0h50(_this__u8e3s4, $completion) {
  var tmp = await_0(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var basis = tmp;
  var tmp_0;
  if (basis == null) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ta5();
    var tmp$ret$1 = cancellable.ua5();
    var tmp_1 = returnIfSuspended(tmp$ret$1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    tmp_0 = basis;
  }
  return tmp_0;
}
function awaitNotNull(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_awaitNotNull__3s0h50.bind(VOID, _this__u8e3s4), $completion);
}
function get_waitForNotNull_0(_this__u8e3s4) {
  return new (WaitForNotNull())(_this__u8e3s4);
}
var WaitForNotNullClass;
function WaitForNotNull() {
  if (WaitForNotNullClass === VOID) {
    class $ {
      constructor(wraps) {
        this.vaq_1 = wraps;
      }
      sah() {
        var tmp;
        if (_ReactiveState___get_raw__impl__92ipya(this.vaq_1.sah()) == null) {
          tmp = Companion_getInstance().oah_1;
        } else {
          var tmp_0 = this.vaq_1.sah();
          tmp = new (ReactiveState())(tmp_0) instanceof ReactiveState() ? tmp_0 : THROW_CCE();
        }
        return tmp;
      }
      vah(listener) {
        return this.vaq_1.vah(listener);
      }
      hashCode() {
        return hashCode(this.vaq_1) + 1 | 0;
      }
      equals(other) {
        var tmp;
        if (other instanceof WaitForNotNull()) {
          tmp = equals(this.vaq_1, other.vaq_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
    }
    protoOf($).kaj = beginUse;
    initMetadataForClass($, 'WaitForNotNull', VOID, VOID, [Reactive()]);
    WaitForNotNullClass = $;
  }
  return WaitForNotNullClass;
}
var waitForNotNull$1Class;
function waitForNotNull$1() {
  if (waitForNotNull$1Class === VOID) {
    class $ {
      constructor($this_waitForNotNull) {
        this.xaq_1 = $this_waitForNotNull;
        var tmp = this;
        tmp.waq_1 = get_waitForNotNull_0(isInterface($this_waitForNotNull, Reactive()) ? $this_waitForNotNull : THROW_CCE());
      }
      yaq(value, $completion) {
        return this.xaq_1.iah(value, $completion);
      }
      iah(value, $completion) {
        return this.yaq(!(value == null) ? value : THROW_CCE(), $completion);
      }
      sah() {
        return this.waq_1.sah();
      }
      vah(listener) {
        return this.waq_1.vah(listener);
      }
      kaj() {
        return this.waq_1.kaj();
      }
    }
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactive(), Reactive()], [1]);
    waitForNotNull$1Class = $;
  }
  return waitForNotNull$1Class;
}
//region block: exports
export {
  get_waitForNotNull_0 as get_waitForNotNull1jl9mx6el51tq,
  get_waitForNotNull as get_waitForNotNull2non1pqjf7sqr,
  awaitNotNull as awaitNotNullzd1xp1uu2voc,
};
//endregion

//# sourceMappingURL=WaitForNotNull.mjs.map
